import styles from "./BudgetBar.module.scss";
import clsx from "clsx";
import React from "react";

export const BudgetBarIn = ({amountFilled, amountPlanned, background = null}) => {
  return <BudgetBar amountFilled={amountFilled} amountPlanned={amountPlanned} progress="5" overspentClass="positive"
                    background={background}/>;
};

export const BudgetBarOut = ({amountFilled, amountPlanned, background = null}) => {
  return <BudgetBar amountFilled={amountFilled} amountPlanned={amountPlanned} overspentClass="negative"
                    background={background}/>;
};

const BudgetBar = ({amountFilled, amountPlanned, overspentClass, progress = null, background = null}) => {

  let minValue = Math.min(Math.abs(amountFilled), Math.abs(amountPlanned));
  let maxValue = Math.max(Math.abs(amountFilled), Math.abs(amountPlanned));

  const percentage = maxValue === 0 ? 0 : Math.round(minValue / maxValue * 100);
  const percentageOver = Math.abs(amountPlanned) > 0 && Math.abs(amountFilled) > Math.abs(amountPlanned) ? 100 - percentage : 0;

  const classes = [styles.progress];

  if (percentageOver > 0) {
    classes.push(styles.noBorderRadius);
  }

  if (progress) {
    classes.push(styles["progress" + progress]);
  } else {
    classes.push(styles["progress" + (percentageOver > 0 ? 100 : Math.floor(percentage / 5) * 5)]);
  }

  return <div className={styles.budgetBar} style={background ? {background} : null}>
    <div style={{width: percentage + "%"}} className={clsx(classes)}/>

    {percentageOver > 0 ?
      <div className={clsx(styles.overspent, styles[overspentClass])} style={{width: percentageOver + "%"}}/> : null}
  </div>;
};
